<template>
	<b-modal id="detail-modal" body-class="pre" hide-footer no-fade v-model="show" :title="title">
		{{content}}
	</b-modal>
</template>

<script>
export default {
	computed: {
		show: {
			get: function(){
				return this.$store.state.modals.detail.show
			},
			set: function(){
				this.$store.dispatch('modals/hideDetails')
			}
		},
		title: function(){
			return this.$store.state.modals.detail.title
		},
		content: function(){
			return this.$store.state.modals.detail.content
		}
	}
}
</script>

<style scoped>

</style>